import {App, Plugin} from 'vue';
import VlUiVueComponents from '@govflanders/vl-ui-design-system-vue3';

export default {
    install(app: App) {
        app.use(VlUiVueComponents);
    }
} as Plugin;
